import { Roles } from "@timhortons/common/src/constants/roles";
import { allRoutesNames as routeNames } from "@timhortons/common/src/utils/allRouteNames";
import React from "react";
const IamModule = React.lazy(() => import("@timhortons/web/src/modules/iam"));
const Login = React.lazy(() => import("@timhortons/common/src/modules/iam/login"));
const ForgotPassword = React.lazy(
  () => import("@timhortons/common/src/modules/iam/forgotPassword")
);
import PageNotFound from "@timhortons/common/src/components/molecules/errorsScreen/pageNotFound";
const iamRoutes = () => {
  return [
    {
      path: routeNames.IAM.root,
      component: IamModule,
      isExact: false,
      permission: [
        // Roles.Admin,
        Roles.AreaManager,
        Roles.StoreAccess,
        Roles.AuditorLP,
        Roles.HeadLP
      ],
      children: [
        {
          path: routeNames.IAM.login,
          component: Login,
          isExact: true,
          permission: [
            // Roles.Admin,
            Roles.AreaManager,
            Roles.StoreAccess,
            Roles.AuditorLP,
            Roles.HeadLP
          ]
        },
        {
          path: routeNames.IAM.forgotPassword,
          isExact: true,
          permission: [
            // Roles.Admin,
            Roles.AreaManager,
            Roles.StoreAccess,
            Roles.AuditorLP,
            Roles.HeadLP
          ],
          component: ForgotPassword
        },
        {
          path: "",
          component: PageNotFound,
          isExact: false
        }
      ]
    }
  ];
};

const iamRouter = () => {
  return iamRoutes();
};

export default iamRouter;
